import { lookupMapping } from "@/lib/mapper/mappers";
import { resolveInputValue } from "@/modules/_shared/templateValue";
import type { CellModule } from "@/modules/_shared/contract";

export const dictionaryModule: CellModule = {
  kind: "dictionary",
  capability: "cell",
  name: "Dictionary",
  tooltip: "Look up a value in a saved dictionary and replace it",
  description:
    "Replaces an input value using a saved dictionary (lookup list). Example: 'rani pink' becomes 'Pink'. Add missing words right from the editor.",
  category: "Rules",
  tags: ["dictionary", "map", "lookup", "normalize", "color", "fabric", "alias"],
  icon: { kind: "lucide", name: "BookA" },
  tone: "sky",
  defaultConfig: () => ({ kind: "dictionary", input: "", dictionary: "", onMiss: "passthrough" }),
  resolve: (rule, { row, helpers, output, dictionaries }) => {
    if (rule.kind !== "dictionary") return "";
    const input = resolveInputValue(rule.input, { row, helpers, output });
    const hit = lookupMapping(input, dictionaries?.[rule.dictionary]);
    if (hit !== undefined) return hit;
    if (rule.onMiss === "default") return rule.default ?? "";
    return input; // passthrough
  },
  templateStrings: (rule) => (rule.kind === "dictionary" ? [rule.input] : []),
};
